<template>
  <div>
    <status-string v-if="status === OrderReconciliationStatus.Mismatch" class="text-red" text="Есть расхождения" />
    <status-string v-if="status === OrderReconciliationStatus.NotReconciled" class="text-blue" text="Требует сверки" />
    <status-string v-if="status === OrderReconciliationStatus.Reconciled" class="text-green" text="Сверено" />
    <status-string v-if="status === OrderReconciliationStatus.ReconciledByAlean" class="text-green" text="Сверено Алеан" />
  </div>
</template>

<script setup lang="ts">
import StatusString from '@/core/components/common/StatusString.vue';
import { OrderReconciliationStatus } from '@/graphql/generated';

defineProps<{
  status: OrderReconciliationStatus;
}>();
</script>

<style scoped lang="scss"></style>
